import moment from 'moment';

import { Box, HStack, VStack } from '@frontend/legacy-components';
import { useDateFormat } from '@frontend/utils';

import { VIEWER_MODES } from 'constants/all';

import HighlightOrDisplay from './HighlightOrDisplay';
import LabelText from './LabelText';
import PartCell from './PartCell';
import ValueText from './ValueText';

const ShareMatchCell = ({ shareResult }) => {
  const isExpired = shareResult.data.isExpired;
  const partResult = shareResult.children?.part?.[0] ?? {
    data: shareResult.data.part[0],
  };
  const primaryFile = partResult.data.partFiles?.find(
    (partFile) => partFile.isPrimaryFile == true,
  );
  const { dateAtTimeFormat } = useDateFormat();
  return (
    <Box alignContent="left">
      <PartCell
        href={
          shareResult.data?.relativeUrl ??
          `/parts/${VIEWER_MODES.SHARE}/${partResult.data.uuid}?version=${shareResult.data.partMasterVersion}&channel_id=${shareResult.data.channelId}`
        }
        partResult={partResult}
        resultOwnerId={shareResult.data.sharedWithId}
        filename={primaryFile ? primaryFile.filename : null}
        primaryFileUuid={primaryFile ? primaryFile.uuid : null}
        customWarning={
          isExpired
            ? {
                color: 'status.notStarted',
                text: 'EXPIRED',
              }
            : undefined
        }
      />
      <HStack paddingTop={1}>
        <VStack alignItems="start" spacing={0}>
          <LabelText>Business Name</LabelText>
          <LabelText>Shared By</LabelText>
          <LabelText>Shared</LabelText>
          <LabelText>{`Expire${isExpired ? 'd' : 's'}`}</LabelText>
          <LabelText>Message</LabelText>
        </VStack>
        <VStack alignItems="start" spacing={0}>
          <HighlightOrDisplay
            result={shareResult}
            field="sharedByBusinessName"
          />
          <HighlightOrDisplay result={shareResult} field="sharedByEmail" />
          <ValueText useDataFont>
            {shareResult.data.created
              ? moment(shareResult.data.created)
                  .subtract(new Date().getTimezoneOffset(), 'minutes')
                  .format(dateAtTimeFormat)
              : '--'}
          </ValueText>
          <ValueText useDataFont>
            {shareResult.data.expirationDate
              ? moment(shareResult.data.expirationDate)
                  .subtract(new Date().getTimezoneOffset(), 'minutes')
                  .format(dateAtTimeFormat)
              : '--'}
          </ValueText>
          <HighlightOrDisplay
            result={shareResult}
            field="message"
            allowNestedLink
          />
        </VStack>
      </HStack>
    </Box>
  );
};

export default ShareMatchCell;
